import YFormDivider from './Divider';

export { YFormDivider };
export default YFormDivider;
